import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=3307d48e&scoped=true"
import script from "./RoleManage.vue?vue&type=script&lang=js"
export * from "./RoleManage.vue?vue&type=script&lang=js"
import style0 from "./RoleManage.vue?vue&type=style&index=0&id=3307d48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3307d48e",
  null
  
)

export default component.exports